import React from 'react'
import Form from 'react-bootstrap/Form';

const InputField = ({pattern,inputFieldLabel, requiredStar,onChange=()=>{},value,editable = true, name, placeholder, disabled=false,ref=null, setValue=()=>{} }) => {
  function changeHandler(e){
    if(inputFieldLabel.toLowerCase() === 'pincode') {
      if(e.target.value.length == 7) return;
      const regex = new RegExp(/^[0-9]*$/)
      if(regex.test(e.target.value)) {
        onChange(e)
        setValue(e.target.value)
        return;
      } else {
        return
      }
    }
    if(inputFieldLabel.toLowerCase() === 'otp') {
      if(e.target.value.length > 6) return;
      const regex = new RegExp(/^[0-9]*$/)
      if(regex.test(e.target.value)) {
        onChange(e)
        setValue(e.target.value)
        return;
      } else {
        return
      }
    }
    onChange(e)
    setValue(e.target.value)
  }
  return (
    <>
     <Form.Label className='form-label'>{inputFieldLabel} <span className='redStar'>{requiredStar}</span></Form.Label>
     {editable == true && 
       <Form.Control
       disabled={disabled}
        type="text"
        inputMode={inputFieldLabel.toLowerCase() === 'otp' ? 'numeric' : undefined}
        maxLength={inputFieldLabel.toLowerCase() === 'otp' ? 6 : undefined}
        onChange ={changeHandler}
        value={value}
        name={name}
        placeholder={placeholder}
        pattern={pattern}
        ref={ref}
        />
     }
     {editable == false && 
       <div className="mobileField">{value}</div>
     }
      

       
        
      
    
    </>
  )
}

export default InputField